<template>
    <wrapper>
        <main class="main-content-wrapper">
            <card>
                <div class="d-flex justify-content-between align-items-start">
                    <h5 class="detail-title">Detail Servis</h5>
                    <span v-if="formData.statusService" :class="statusBadgeClass(formData.statusService)">
                        {{ formData.statusService }}
                    </span>
                </div>

                <div class="ringkasan-box">
                    <div class="section-header">RINGKASAN SERVIS</div>
                    <div class="section-body">
                        <div class="row">
                            <div class="col-lg-4">
                                <p class="summary-label">Nama Vendor</p>
                                <p class="summary-value">{{ formData.vendorName || '-' }}</p>
                            </div>
                            <div class="col-lg-4">
                                <p class="summary-label">Tanggal Dibuat</p>
                                <p class="summary-value">{{ formData.createdAt || '-' }}</p>
                            </div>
                            <div class="col-lg-4">
                                <p class="summary-label">Dibuat Oleh</p>
                                <p class="summary-value">{{ formData.createdByName || '-' }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="hasCompletedItems" class="status-box completed-box">
                    <div class="status-box-header status-header-completed">SUDAH SELESAI DISERVIS</div>
                    <div class="section-body">
                        <div class="item-table-wrapper">
                            <table class="table item-table completed-table mb-0">
                                <thead>
                                    <tr>
                                        <th rowspan="2" class="align-middle col-divider">NAMA ITEM</th>
                                        <th colspan="2" class="text-center col-divider">SERIAL NUMBER/BATCH NUMBER</th>
                                        <th colspan="2" class="text-center">DETAIL PENYELESAIAN</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center col-divider sn-col"><span class="sn-badge sn-badge-lama">Lama</span></th>
                                        <th class="text-center col-divider sn-col"><span class="sn-badge sn-badge-baru">Baru</span></th>
                                        <th class="text-center col-divider sn-col">METODE</th>
                                        <th class="text-center col-divider sn-col">BIAYA SERVIS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in formData.completedItems" :key="`completed-item-${index}`">
                                        <td class="col-divider">{{ item.itemName }}</td>
                                        <td class="col-divider">
                                            <div class="sn-detail-row">
                                                <span class="sn-badge sn-badge-lama">SN/Batch Number</span>
                                                <div class="sn-detail-value">{{ item.oldSNBatchNumber || '-' }}</div>
                                            </div>
                                            <div class="sn-detail-row">
                                                <span class="sn-badge sn-badge-lama">Stock Code</span>
                                                <div class="sn-detail-value">{{ item.stockCode || '-' }}</div>
                                            </div>
                                        </td>
                                        <td class="col-divider">
                                            <div class="sn-detail-row">
                                                <span class="sn-badge sn-badge-baru">SN/Batch Number</span>
                                                <div class="sn-detail-value">{{ item.newSNBatchNumber || '-' }}</div>
                                            </div>
                                            <div class="sn-detail-row">
                                                <span class="sn-badge sn-badge-baru">Stock Code</span>
                                                <div class="sn-detail-value">{{ item.newStockCode || '-' }}</div>
                                            </div>
                                        </td>
                                        <td class="col-divider text-center">{{ item.resolutionLabel || '-' }}</td>
                                        <td class="col-divider text-center">{{ item.serviceFee || '-' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <p v-if="!hasCompletedItems" class="item-list-label">Daftar item yang sedang diservis</p>

                <div class="item-table-wrapper" :class="{ 'status-box pending-box': hasCompletedItems }">
                    <div v-if="hasCompletedItems" class="status-box-header status-header-pending">BELUM SELESAI DISERVIS</div>
                    <table class="table item-table mb-0">
                        <thead>
                            <tr>
                                <th class="checkbox-col" v-if="allowEditService">
                                    <input
                                        type="checkbox"
                                        :checked="allChecked"
                                        :disabled="!canProcessService"
                                        @change="toggleSelectAll()"
                                    />
                                </th>
                                <th>NAMA ITEM</th>
                                <th>SERIAL NUMBER/BATCH NUMBER</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="loadingPage">
                                <td colspan="3" class="text-center">
                                    <img src="~@/assets/images/load-button.gif" />
                                </td>
                            </tr>
                            <tr v-else-if="formData.pendingItems.length === 0">
                                <td colspan="3" class="text-center">Data Not Available</td>
                            </tr>
                            <tr v-for="(item, index) in formData.pendingItems" v-else :key="`service-item-${index}`">
                                <td class="checkbox-col" v-if="allowEditService">
                                    <input
                                        type="checkbox"
                                        v-model="item.checked"
                                        :disabled="!canProcessService"
                                    />
                                </td>
                                <td>{{ item.itemName }}</td>
                                <td>{{ item.snBatchNumber || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p class="helper-note"><i class="fa fa-info-circle"></i> Centang item untuk memproses penyelesaian servis.</p>
            </card>

            <div class="mt-3 d-flex justify-content-between">
                <button class="btn btn-outline-secondary back-btn" @click="toServicePage()">
                    &#8592; Kembali
                </button>
                <div v-if="canProcessService">
                    <button
                        class="btn btn-outline-danger cancel-btn mr-2"
                        :disabled="loadingBtnCancel"
                        @click="batalkanServis()"
                        v-if="allowDeleteService"
                    >
                        <img src="~@/assets/images/2.gif" style="height: 24px" v-if="loadingBtnCancel"/>
                        {{ loadingBtnCancel ? 'Membatalkan...' : 'Batalkan Seluruh Servis' }}
                    </button>
                    <button
                        class="btn btn-primary complete-btn"
                        :disabled="checkedCount === 0 || loadingBtnComplete"
                        @click="selesaikanServis()"
                        v-if="allowEditService"
                    >
                        {{ loadingBtnComplete ? 'Memproses...' : `Selesaikan Servis (${checkedCount})` }}
                    </button>
                </div>
            </div>
        </main>

        <ModalFinishService
            ref="modalFinishService"
            :loading="loadingBtnComplete"
            @simpan="handleFinishServiceSubmit"
        />

        <ModalCancelAllService
            ref="modalCancelAllService"
            :loading="loadingBtnCancel"
            @simpan="handleCancelServiceSubmit"
        />
    </wrapper>
</template>

<script>
import Swal from 'sweetalert2';
import { Wrapper, Card } from '../Layout';
import ModalFinishService from './CustomComponent/ModalFinishService.vue';
import ModalCancelAllService from './CustomComponent/ModalCancelAllService.vue';

export default {
    name: 'ServiceDetailPage',
    components: {
        Wrapper,
        Card,
        ModalFinishService,
        ModalCancelAllService,
    },
    data() {
        return {
            allowEditService: false, 
            allowDeleteService: false, 
            loadingPage: true,
            loadingBtnComplete: false,
            loadingBtnCancel: false,
            formData: {
                serviceCode: '',
                vendorName: '',
                createdAt: '',
                createdByName: '',
                statusService: '',
                pendingItems: [],
                completedItems: [],
            },
        };
    },
    computed: {
        checkedCount() {
            return this.formData.pendingItems.filter((item) => item.checked).length;
        },
        allChecked() {
            return this.formData.pendingItems.length > 0 && this.formData.pendingItems.every((item) => item.checked);
        },
        canProcessService() {
            return ['sedang diservis', 'selesai sebagian'].includes((this.formData.statusService || '').toLowerCase());
        },
        hasCompletedItems() {
            return (this.formData.completedItems || []).length > 0;
        },
    },
    methods: {
        cekPermission() {
            this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
            if(!this.permission.includes('27.1')) {
                this.$router.push('/');
            }
            if(this.permission.includes('27.2')) {
                this.allowEditService = true;
            }
            if(this.permission.includes('27.4')) {
                this.allowDeleteService = true;
            }

        },
        statusBadgeClass(status) {
            const map = {
                'sedang diservis': 'service-badge service-badge-progress',
                'selesai sebagian': 'service-badge service-badge-partial',
                'selesai': 'service-badge service-badge-done',
                'dibatalkan': 'service-badge service-badge-cancelled',
            };
            return map[(status || '').toLowerCase()] || 'service-badge service-badge-progress';
        },
        toggleSelectAll() {
            const next = !this.allChecked;
            this.formData.pendingItems.forEach((item) => {
                item.checked = next;
            });
        },
        getDetailData() {
            this.loadingPage = true;

            // TODO: replace with a real call to process.env.GET_SERVICE_DETAIL once the endpoint exists
            const serviceId = this.$route.params.id;
            this.$http.get(process.env.SERVICE_GET_DETAIL + '/' + serviceId,
               {
                headers: { 'Asani-Token': localStorage.getItem('jwt') },
            }).then(response => {
                if (response.data.status !== 200 || response.status !== 200) {

                } else {
                    const content = response.data.data
                    const {id, serviceCode, vendorName, createdBy, createdDate, statusLabel, pendingItems, completedItems} = content
                    this.formData = {
                        serviceId: id,
                        serviceCode: serviceCode,
                        vendorName: vendorName,
                        createdAt: createdDate,
                        createdByName: createdBy,
                        statusService: statusLabel,
                        pendingItems: pendingItems.map((item) => ({...item, checked: false,})),
                        completedItems: completedItems,
                    };
                }
                this.loadingPage = false;
            }).catch((error) => {
                this.loadingPage = false;
                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                    confirmButton: "btn btn-primary ml-2",
                    cancelButton: "btn btn-danger",
                    },
                    buttonsStyling: false,
                });
                swalWithBootstrapButtons.fire({ title: 'Sorry', text: error.response.data.message, icon: 'error' }).then(() => {
                    if (error.response.data.status === 401) {
                        this.handleLogout();
                    }
                });
            });
        },
        selesaikanServis() {
            if (this.checkedCount === 0) return;
            const checkedItems = this.formData.pendingItems.filter((item) => item.checked);
            this.$refs.modalFinishService.showModal(
                {
                    vendorName: this.formData.vendorName,
                    createdAt: this.formData.createdAt,
                    createdByName: this.formData.createdByName,
                },
                checkedItems
            );
        },
        handleFinishServiceSubmit(items) {
            this.loadingBtnComplete = true;
            this.$http
                .post(
                    process.env.SERVICE_SAVE,
                    {
                        serviceId : this.formData.serviceId,
                        vendorName: this.formData.vendorName,
                        stage: 'submit',
                        items: items
                    },
                    { headers: { 'Asani-Token': localStorage.getItem('jwt') } }
                )
                .then((response) => {
                    this.loadingBtnComplete = false;
                    const swalWithBootstrapButtons = Swal.mixin({
                        customClass: {
                        confirmButton: "btn btn-primary ml-2",
                        cancelButton: "btn btn-danger",
                        },
                        buttonsStyling: false,
                    });
                    if (response.data.status === 200) {
                        this.$refs.modalFinishService.closeModal();
                        swalWithBootstrapButtons.fire({ title: 'Success', text: response.data.message, icon: 'success' }).then(() => {
                            this.getDetailData();
                        });
                    } else {
                        swalWithBootstrapButtons.fire({ title: 'Sorry', text: response.data.message, icon: 'error' });
                    }
                })
                .catch((error) => {
                    this.loadingBtnComplete = false;
                    const swalWithBootstrapButtons = Swal.mixin({
                        customClass: {
                        confirmButton: "btn btn-primary ml-2",
                        cancelButton: "btn btn-danger",
                        },
                        buttonsStyling: false,
                    });
                    swalWithBootstrapButtons.fire({ title: 'Sorry', text: error.response.data.message, icon: 'error' }).then(() => {
                        if (error.response.data.status === 401) {
                            this.handleLogout();
                        }
                    });
                });
        },
        batalkanServis() {
            this.$refs.modalCancelAllService.showModal();
        },
        handleCancelServiceSubmit(reason) {
            this.loadingBtnCancel = true;
            this.$http
                .post(
                    process.env.SERVICE_SAVE,
                    { 
                        serviceId : this.formData.serviceId,
                        stage: 'cancel',
                        cancellationReason: reason,
                    },
                    { headers: { 'Asani-Token': localStorage.getItem('jwt') } }
                )
                .then((response) => {
                    this.loadingBtnCancel = false;
                    const swalWithBootstrapButtons = Swal.mixin({
                        customClass: {
                        confirmButton: "btn btn-primary ml-2",
                        cancelButton: "btn btn-danger",
                        },
                        buttonsStyling: false,
                    });
                    if (response.data.status === 200) {
                        this.$refs.modalCancelAllService.closeModal();
                        swalWithBootstrapButtons.fire({ title: 'Success', text: response.data.message, icon: 'success' }).then(() => {
                            this.getDetailData();
                        });
                    } else {
                        swalWithBootstrapButtons.fire({ title: 'Sorry', text: response.data.message, icon: 'error' });
                    }
                })
                .catch((error) => {
                    this.loadingBtnCancel = false;
                    const swalWithBootstrapButtons = Swal.mixin({
                        customClass: {
                        confirmButton: "btn btn-primary ml-2",
                        cancelButton: "btn btn-danger",
                        },
                        buttonsStyling: false,
                    });
                    swalWithBootstrapButtons.fire({ title: 'Sorry', text: error.response.data.message, icon: 'error' }).then(() => {
                        if (error.response.data.status === 401) {
                            this.handleLogout();
                        }
                    });
                });
        },
        toServicePage() {
            this.$router.push({
                path: '/service',
                query: {
                    serviceId: '',
                    vendorName: '',
                    createdAt: '',
                    createdBy: '',
                    status: '',
                    page: 1,
                    itemPerPage: 10,
                },
            });
        },
        async handleLogout() {
            try {
                await this.$http.post(process.env.LOGOUT, {}, {
                    headers: { 'Asani-Token': localStorage.getItem('jwt') },
                });
            } catch (error) {
                if (error.response.data.status !== 401) return;
            }
            localStorage.removeItem('jwt');
            localStorage.removeItem('admin_name');
            localStorage.removeItem('roles');
            localStorage.removeItem('user_email');
            localStorage.removeItem('admin_id');
            this.$router.push('/');
        },
        cekLogin() {
            if (localStorage.getItem('jwt') == null) {
                this.$router.push('/');
            }
        },
    },
    created() {
        this.cekLogin();
        this.cekPermission();
        this.getDetailData();
    },
};
</script>

<style scoped>
.main-content-wrapper {
    padding: 24px;
}

.detail-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0;
    color: #212529;
}

.service-badge {
    display: inline-block;
    padding: 4px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid transparent;
    white-space: nowrap;
}

.service-badge-progress {
    color: #c98a06;
    background: #fff6e0;
    border-color: #f5e2ad;
}

.service-badge-partial {
    color: #0d6efd;
    background: #e7f1ff;
    border-color: #b6d4fe;
}

.service-badge-done {
    color: #28a745;
    background: #e8f8ee;
    border-color: #c3ecd2;
}

.service-badge-cancelled {
    color: #6c757d;
    background: #eef1f4;
    border-color: #dfe4e8;
}

.ringkasan-box {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 20px;
}

.section-header {
    background: #f8f9fa;
    padding: 10px 20px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #495057;
    border-bottom: 1px solid #e9ecef;
}

.section-body {
    padding: 20px;
}

.summary-label {
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 4px;
}

.summary-value {
    font-size: 14px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 0;
}

.item-list-label {
    font-size: 14px;
    font-weight: 600;
    color: #212529;
    margin-top: 20px;
    margin-bottom: 10px;
}

.item-table-wrapper {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
}

.status-box {
    border-radius: 8px;
    overflow: hidden;
    margin-top: 20px;
    margin-bottom: 20px;
}

.completed-box {
    border: 1px solid #cdeedd;
}

.pending-box {
    border: 1px solid #cfe0fb;
}

.status-box-header {
    padding: 10px 20px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.status-header-completed {
    background: #eafaf0;
    color: #1f9254;
    border-bottom: 1px solid #cdeedd;
}

.status-header-pending {
    background: #eaf2ff;
    color: #1f6fd1;
    border-bottom: 1px solid #cfe0fb;
}

.sn-badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
}

.sn-badge-lama {
    background: #f1f3f5;
    color: #6c757d;
}

.sn-badge-baru {
    background: #e7f1ff;
    color: #0d6efd;
}

.sn-detail-row {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #e9ecef;
}

.sn-detail-row:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: none;
}

.sn-detail-row .sn-badge {
    margin-bottom: 4px;
}

.sn-detail-value {
    font-size: 13px;
    color: #343a40;
}

.item-table {
    margin-bottom: 0;
}

.item-table thead th {
    font-size: 12px;
    font-weight: 700;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    background-color: #f8f9fa;
    border-top: none;
    border-bottom: 1px solid #e9ecef;
    padding: 12px 16px;
    white-space: nowrap;
}

.item-table tbody td {
    vertical-align: middle;
    font-size: 13px;
    color: #343a40;
    padding: 12px 16px;
    border-top: none;
    border-bottom: 1px solid #f1f3f5;
}

.item-table tbody tr:last-child td {
    border-bottom: none;
}

.completed-table .col-divider {
    border-right: 1px solid #e9ecef;
}

.completed-table .sn-col {
    width: 160px;
}

.checkbox-col {
    width: 40px;
}

.checkbox-col input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: #247fec;
    cursor: pointer;
}

.helper-note {
    font-size: 12px;
    color: #6c757d;
    margin-top: 10px;
    margin-bottom: 0;
}

.back-btn {
    font-size: 13px;
    border-color: #dee2e6;
    color: #343a40;
    background: #fff;
    padding: 6px 16px;
}

.back-btn:hover {
    background-color: #f8f9fa;
}

.cancel-btn {
    font-size: 13px;
    padding: 6px 20px;
}

.complete-btn {
    font-size: 13px;
    padding: 6px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Service/ServiceDetailPage.vue